import { Pipe, PipeTransform } from "@angular/core";
import { IWFDSSUserRoleType } from "src/app/_interfaces/auth/IWfdssUserRoleType";
import { User } from "src/app/_models";
import { UserRoleType } from "src/app/_models/user/userRoleType";
import {IWFDSSUserElevatedRoleTypeList} from './../../_interfaces/auth/IWfdssUserRoleType'
@Pipe({
    name: 'userHasRole',
    standalone: false
})
  export class UserHasRolePipe implements PipeTransform {
    transform(user: User, arg:IWFDSSUserRoleType[] | "elevated" | "notViewer"): boolean {
        const role = user.role.roleType as IWFDSSUserRoleType
        if(arg == "elevated"){
            return IWFDSSUserElevatedRoleTypeList.includes(role)
        }
        if(arg == "notViewer"){
            return role != "WFDSS_VIEWER"
        }
        return arg.includes(role as IWFDSSUserRoleType)
    }
  }